import * as yup from 'yup'
import { isValidCarrierMcDigits } from '@numeo/types-core'

export interface CompanyInfoFormData {
    companyName: string
    mcNumber: string
    dotNumber?: string
    dba?: string
    fein?: string
    address1: string
    address2?: string
    city: string
    state: string
    zipCode: string
    email: string
    phoneNumber: string
    details?: string
}

export interface DatCredentialsFormData {
    orgUsername: string
    orgPassword: string
    username: string
}

// This interface is no longer needed since we fixed the main interface
/* export interface DatCredentialsFormValues {
    orgUsername: string
    orgPassword: string
    username: string
    emails: string[]
} */

export const companyInfoValidationSchema = yup.object({
    companyName: yup.string().required('Company name is required'),
    mcNumber: yup
        .string()
        .required('MC number is required')
        .test('valid-carrier-mc', 'MC number must be 4-9 digits', (value) => value == null || isValidCarrierMcDigits(value)),
    dotNumber: yup.string(),
    dba: yup.string(),
    fein: yup.string(),
    address1: yup.string().required('Address is required'),
    address2: yup.string(),
    city: yup.string().required('City is required'),
    state: yup.string().required('State is required'),
    zipCode: yup.string().required('ZIP code is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    phoneNumber: yup.string().required('Phone number is required'),
    details: yup.string(),
})

export const datCredentialsValidationSchema = yup.object().shape({
    orgUsername: yup.string().required('Organization username is required'),
    orgPassword: yup.string().required('Organization password is required'),
    username: yup.string().required('Username is required'),
})
